export default "__VITE_ASSET__1b904836__"